import _ from 'lodash';
import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { CustomerContextProvider } from 'components/customer/customer_context';
import { CustomerFooterRefProvider } from 'components/customer/customer_footer_ref_context';
import { getLatestConversationId } from 'actions/conversation/lib/conversation_helpers';
import AnswerPanel from 'components/customer/answer_panel';
import AnswerPanelToggleButton from 'components/customer/answer_panel/answer_panel_toggle_button';
import MobileKeyboardKeepAlive from 'components/mobile/mobile_keyboard_keep_alive';
import Composition from './customer/composition';
import connect from 'components/lib/connect';
import ConversationHistory from 'components/customer/conversation_history/conversation_history';
import CustomerFooter from 'components/customer/customer_footer';
import CustomerNotAssignedToCurrentAgentBanner from 'components/customer/customer_not_assigned_to_current_agent_banner';
import CustomerNotFound from 'components/customer/customer_not_found';
import CustomerPageViewedTracker from 'components/customer/customer_page_viewed_tracker';
import CustomerSidePanel from 'components/customer/customer_side_panel';
import CustomerSummary from 'components/customer/customer_summary';
import CustomerWasCombined from 'components/customer/customer_was_combined';
import { Device } from 'scripts/lib/device_detector';
import GreetingSuggestionsProvider from 'components/composer/contexts/greeting_suggestions_context';
import KeyPressShortcutMixin from 'components/lib/keypress_shortcut_mixin';
import { useMobilePanel } from 'components/mobile/mobile_context';
import OpenAnswerPanel from 'actions/answers/open_answer_panel';
import PhraseSuggestionsProvider from 'components/composer/contexts/phrase_suggestions_context';
import registerHotkey from 'components/hotkeys/register_hotkey';
import SwitchToInbox from 'actions/inbox/switch_to_inbox';
import TaskCommentPanel from 'components/customer/task_comments/task_comment_panel';
import TaskCommentPanelToggleButton from 'components/customer/task_comments/task_comment_panel_toggle_button';
import TeamAssistPanel from 'components/customer/team_assist/team_assist_panel';
import TeamAssistPanelToggleButton from 'components/customer/team_assist/team_assist_panel_toggle_button';
import ToggleAnswerPanel from 'actions/answers/toggle_answer_panel';
import useDevice from 'components/hooks/use_device';
import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';
import useIsTeamAssistEnabled from 'components/hooks/use_is_team_assist_enabled';
import VariablesProvider from 'components/composer/contexts/variables_context';
import withShortcuts from 'scripts/presentation/decorators/keypress_shortcut_decorator';
import SidePanel, { SidePanelType } from 'models/side_panel';

const Customer = createReactClass({
  mixins: [new KeyPressShortcutMixin()],

  propTypes: {
    currentAgentId: PropTypes.string,
    customerExists: PropTypes.bool,
    customerId: PropTypes.string.isRequired,
    hasConversationGeneral: PropTypes.bool,
    hasSelectedTask: PropTypes.bool,
    isAnswersReadEnabled: PropTypes.bool,
    isFullHeightSidePanel: PropTypes.bool,
    isPhone: PropTypes.bool,
    latestConversationId: PropTypes.string,
    onInboxShortcut: PropTypes.func,
    openAnswerPanel: PropTypes.func,
    sidePanel: PropTypes.instanceOf(SidePanel),
    toggleAnswerPanel: PropTypes.func,
  },

  render() {
    return (
      <div className="customerV2Container" id="customer">
        {this.renderCustomer()}
      </div>
    );
  },

  renderCustomer() {
    if (this.props.mergedCustomerId) {
      return <CustomerWasCombined customerId={this.props.mergedCustomerId} />;
    } else if (!this.props.customerExists) {
      return <CustomerNotFound />;
    }

    return this.renderCustomerLayout();
  },

  renderCustomerLayout() {
    const { isPhone } = this.props;
    const contentArea = (
      <CustomerAssignmentBannerWrapper>
        <CustomerNotAssignedToCurrentAgentBanner />
        <CustomerContent>
          {!isPhone && <CustomerSummary />}
          <ConversationFeed
            currentCompositionId={this.props.currentCompositionId}
            customerId={this.props.customerId}
            hasSelectedTask={this.props.hasSelectedTask}
            isAnswersReadEnabled={this.props.isAnswersReadEnabled}
            onToggleAnswerPanel={this.handleToggleAnswerPanel}
            sidePanel={this.props.sidePanel}
          />
        </CustomerContent>
      </CustomerAssignmentBannerWrapper>
    );

    // CustomerFooter already branches on useDevice() internally and renders
    // <MobileFooter /> for phones, so we don't need to force isCompactMode
    // here just because we're on a phone. Pass only the side-panel flag and
    // let the footer pick the right variant.
    const footer = this.props.hasConversationGeneral ? (
      <CustomerFooter isCompactMode={this.props.isFullHeightSidePanel} />
    ) : null;

    if (isPhone) {
      return (
        <CustomerProviders>
          <CustomerPage>
            <CustomerPageViewedTracker customerId={this.props.customerId} />
            <CustomerAnswerWrapper>{contentArea}</CustomerAnswerWrapper>
            {footer}
            <MobileFullScreenPanel />
          </CustomerPage>
        </CustomerProviders>
      );
    }

    if (this.props.isFullHeightSidePanel) {
      return (
        <CustomerProviders>
          <CustomerPage>
            <CustomerPageViewedTracker customerId={this.props.customerId} />
            <CustomerOuterWrapper>
              <CustomerLeftColumn>
                <CustomerAnswerWrapper>{contentArea}</CustomerAnswerWrapper>
                {footer}
              </CustomerLeftColumn>
              <CustomerSidePanel />
            </CustomerOuterWrapper>
          </CustomerPage>
        </CustomerProviders>
      );
    }

    return (
      <CustomerProviders>
        <CustomerPage>
          <CustomerPageViewedTracker customerId={this.props.customerId} />
          <CustomerAnswerWrapper>
            {contentArea}
            <CustomerSidePanel />
          </CustomerAnswerWrapper>
          {footer}
        </CustomerPage>
      </CustomerProviders>
    );
  },

  handleInboxShortcut() {
    this.props.onInboxShortcut();
  },

  handleOpenAnswerPanel() {
    this.props.openAnswerPanel({
      customerId: this.props.customerId,
      conversationId: this.props.latestConversationId,
      compositionId: undefined,
    });
  },

  handleToggleAnswerPanel() {
    this.props.toggleAnswerPanel({
      conversationId: this.props.latestConversationId,
      customerId: this.props.customerId,
      compositionId: undefined,
    });
  },
});

const CustomerPage = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  height: inherit;
  min-width: 0;
  position: relative;
`;

const CustomerAnswerWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  height: 100%;
  min-height: 0;
  position: relative;
`;

const CustomerOuterWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  height: 100%;
  min-height: 0;
  position: relative;
`;

const CustomerLeftColumn = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
`;

const CustomerAssignmentBannerWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  min-width: 0;
  position: relative;
`;

const CustomerContent = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  position: relative;

  [data-device='phone'] & {
    flex-direction: column;
  }
`;

const CustomerWithShortcuts = withShortcuts(Customer, [
  registerHotkey({
    key: 'alt+i',
    callback: component => component.handleInboxShortcut(),
    label: 'Go back to inbox',
    group: 'Customer',
  }),
  registerHotkey({
    key: 'ctrl+/',
    callback: component => component.handleOpenAnswerPanel(),
    label: 'Open answers side panel',
    group: 'Customer',
  }),
]);

export { Customer, CustomerWithShortcuts };

const ConnectedCustomer = connect(mapStateToProps, mapExecuteToProps)(CustomerWithShortcuts);

// Sources `isPhone` from DeviceContext (rather than calling getDevice() inside
// mapStateToProps, which bypasses the provider and can drift from the in-tree
// classification on resize). The connected component is class-based via
// createReactClass, so a small functional shim is the cleanest injection point.
function CustomerContainer(props) {
  const isPhone = useDevice() === Device.Phone;
  return <ConnectedCustomer {...props} isPhone={isPhone} />;
}

CustomerContainer.propTypes = {
  customerId: PropTypes.string.isRequired,
};

export default CustomerContainer;

function mapStateToProps({ getProvider, isFeatureEnabled }, { customerId }) {
  const customerMerge = getProvider('customerMerge').get();
  const mergedCustomerId =
    customerMerge && _.get(customerMerge, 'sourceCustomerId') === customerId && _.get(customerMerge, 'destCustomerId');

  let latestConversationId = getLatestConversationId(getProvider('conversations'));
  const profileProvider = getProvider('profile');
  const customerProfileExists = profileProvider.isLoading() || !!profileProvider.get();
  const isAnswersReadEnabled = isFeatureEnabled('answers:read');

  return {
    activeCall: getProvider('activeCall').get(),
    currentAgentId: getProvider('currentAgent').get().id,
    currentCompositionId: getProvider('currentLocation').get().currentCompositionId,
    customerExists: customerProfileExists,
    customerId,
    hasConversationGeneral: isFeatureEnabled('conversation:general'),
    hasSelectedTask: !!getProvider('commentPanel').get().selectedItemId,
    isAnswersReadEnabled,
    isFullHeightSidePanel: isFeatureEnabled('fullHeightSidePanel'),
    latestConversationId,
    mergedCustomerId,
    sidePanel: getProvider('sidePanel').get(),
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onInboxShortcut: () => executeAction(SwitchToInbox),
    openAnswerPanel,
    toggleAnswerPanel,
  };

  function toggleAnswerPanel(attrs) {
    executeAction(ToggleAnswerPanel, attrs);
  }

  function openAnswerPanel(attrs) {
    executeAction(OpenAnswerPanel, attrs);
  }
}

function CustomerProviders({ children }) {
  return (
    <CustomerContextProvider>
      <CustomerFooterRefProvider>
        <VariablesProvider>
          <GreetingSuggestionsProvider>
            <PhraseSuggestionsProvider>
              {children}
              <MobileKeyboardKeepAlive />
            </PhraseSuggestionsProvider>
          </GreetingSuggestionsProvider>
        </VariablesProvider>
      </CustomerFooterRefProvider>
    </CustomerContextProvider>
  );
}

export function ConversationFeed({
  currentCompositionId,
  customerId,
  hasSelectedTask,
  isAnswersReadEnabled,
  onToggleAnswerPanel,
  sidePanel,
}) {
  const isTeamAssistEnabled = useIsTeamAssistEnabled();
  const isPhone = useDevice() === Device.Phone;

  const isAnswerPanelOpen = sidePanel.isShowing(SidePanelType.ANSWER);
  const isTeamAssistPanelOpen = sidePanel.isShowing(SidePanelType.AI_ASSIST);
  const isCommentPanelOpen = sidePanel.isShowing(SidePanelType.TASK);
  const isAnyPanelOpen = sidePanel.isOpen();

  return (
    <div className="customerV2-feed customerV2-flatFeed">
      {!isPhone && (
        <PanelToggleStack>
          {isTeamAssistEnabled && (
            <TeamAssistPanelToggleButton
              isActive={isTeamAssistPanelOpen || sidePanel.isShowing(SidePanelType.NONE)}
              isPanelOpen={isAnyPanelOpen}
            />
          )}
          {isAnswersReadEnabled && (
            <AnswerPanelToggleButton
              isActive={isAnswerPanelOpen || sidePanel.isShowing(SidePanelType.NONE)}
              isPanelOpen={isAnyPanelOpen}
              onToggleAnswerPanel={onToggleAnswerPanel}
            />
          )}
          <TaskCommentPanelToggleButton isActive={isCommentPanelOpen} isVisible={hasSelectedTask} />
        </PanelToggleStack>
      )}
      <ConversationHistory customerId={customerId} />
      <Composition currentCompositionId={currentCompositionId} />
    </div>
  );
}

const PanelToggleStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  position: absolute;
  right: 0;
  top: 13px;
  z-index: 6;
`;

ConversationFeed.propTypes = {
  currentCompositionId: PropTypes.string,
  customerId: PropTypes.string.isRequired,
  hasSelectedTask: PropTypes.bool,
  isAnswersReadEnabled: PropTypes.bool,
  onToggleAnswerPanel: PropTypes.func.isRequired,
  sidePanel: PropTypes.instanceOf(SidePanel),
};

function MobileFullScreenPanel() {
  const { mobilePanel } = useMobilePanel();
  const isFeatureEnabled = useIsFeatureEnabled();
  const isAnswersReadEnabled = isFeatureEnabled('answers:read');
  const isTeamAssistEnabled = useIsTeamAssistEnabled();

  // Profile stays mounted (hidden via CSS) so scroll position is preserved when
  // flipping between conversation and profile. Other panels mount/unmount normally.
  const profileVisible = mobilePanel === 'profile';
  const otherPanel =
    (mobilePanel === 'answers' && isAnswersReadEnabled && <AnswerPanel />) ||
    (mobilePanel === 'team-assist' && isTeamAssistEnabled && <TeamAssistPanel />) ||
    (mobilePanel === 'tasks' && <TaskCommentPanel />) ||
    null;

  return (
    <>
      <MobilePanelOverlay $hidden={!profileVisible}>
        <CustomerSummary />
      </MobilePanelOverlay>
      {otherPanel && <MobilePanelOverlay>{otherPanel}</MobilePanelOverlay>}
    </>
  );
}

const MobilePanelOverlay = styled.div`
  background-color: ${p => p.theme.colors.white};
  display: ${p => (p.$hidden ? 'none' : 'flex')};
  flex-direction: column;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 5;

  /* && bumps specificity so child panels' fixed widths (e.g. CustomerSummary's
     360px) don't leak into the full-width overlay. */
  && > * {
    flex: 1 1 auto;
    height: 100%;
    max-width: 100%;
    min-width: 0;
    width: 100%;
  }
`;
